import { isNull } from '@/shared/utils/utils';

export class Settings {
    listFilter: string
    hideDefaultTrackingDomains: boolean

    static parseJson(json: any): Settings {
        if (isNull(json)) { return null; }

        return Object.assign(new Settings(), json);
    }
}